import { Video } from 'lucide-react';

export function Brand({ compact }: { compact?: boolean }) {
  return (
    <a className="brand" href="/" aria-label="Nexo Meet, inicio">
      <span className="brand-mark">
        <Video size={18} strokeWidth={2.4} />
      </span>
      {!compact && (
        <span>
          Nexo <small>Meet</small>
        </span>
      )}
    </a>
  );
}
